import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
const NotFound: FC = () => {
  const { t } = useTranslation(['notFound']);
  return <div>{t('Page is not found')}</div>;
};

export default NotFound;
